'use client';

import { useEffect } from 'react';
import { captureAttribution } from '@/lib/attribution';

const CONSENT_KEY = 'cookie_consent';

export function AttributionCapture() {
  useEffect(() => {
    const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const hasConsent = localStorage.getItem(CONSENT_KEY) === 'accepted';

    // On localhost (dev) always capture so UTM testing works without cookie consent.
    // In production, require explicit consent before firing the session beacon.
    if (isDev || hasConsent) {
      captureAttribution();
    }

    const handleAccept = () => captureAttribution();
    window.addEventListener('cookieConsentAccepted', handleAccept);
    return () => window.removeEventListener('cookieConsentAccepted', handleAccept);
  }, []);

  return null;
}
